import {
    type ApplyV2CustomFieldType,
    ApplyV2CustomFieldTypeConst,
    type ApplyV2Question,
} from '@core/app/types/applyV2Type'
import ApplyV2QuestionsItem from '@core/components/ApplyDialogV2/ApplyV2QuestionsStep/ApplyV2QuestionsItem'

interface ApplyV2QuestionsListProps {
    questions: ApplyV2Question[] | undefined | null
    // parentQuestionId?: number | null
    // parentOptionId?: number | null
    // parentValue?: any
    setIsErrorUpdateAnswer: (value: boolean) => void
    refetchAllQuestions: () => void
    parent?:
        | {
              parentValue: any
              parentType: ApplyV2Question['type'] | null
              parentQuestionId: number | null
              parentOptionId: number | null
              customFieldType: ApplyV2CustomFieldType | null
          }
        | null
        | undefined
    addLoadingItem: (v: string) => void
    removeLoadingItem: (v: string) => void
    setIsQualifyingError: (value: boolean) => void
}
const baseClass = 'ApplyV2QuestionsStep'

function ApplyV2QuestionsList({
    questions,
    // parentQuestionId = 0,
    // parentValue,
    // parentOptionId,
    setIsErrorUpdateAnswer,
    refetchAllQuestions,
    parent = {
        parentQuestionId: 0,
        parentValue: null,
        parentOptionId: null,
        parentType: null,
        customFieldType: null,
    },
    addLoadingItem,
    removeLoadingItem,
    setIsQualifyingError,
}: ApplyV2QuestionsListProps) {
    if (!questions || !questions.length) return null

    const orderedQuestions = [...questions].sort((a, b) => a.orderId - b.orderId)

    return (
        <div
            className={`${baseClass}__question--children`}
            style={{
                paddingLeft: parent?.parentQuestionId && parent?.parentQuestionId > 0 ? '14px' : '0',
                borderLeft: parent?.parentQuestionId && parent?.parentQuestionId > 0 ? '1px solid #E2E8F0' : 'none',
            }}
        >
            {orderedQuestions
                .filter((quest) => {
                    switch (parent?.parentType) {
                        case 'multiSelect':
                            return (Array.isArray(parent.parentValue) ? parent.parentValue : []).includes(
                                quest.parentOptionId
                            )
                        case 'singleSelect':
                        case 'yesNo':
                        case 'qualifying':
                            return parent.parentValue && quest.parentOptionId === parent.parentValue
                        case 'customField':
                            switch (parent?.customFieldType) {
                                case ApplyV2CustomFieldTypeConst.SingleSelect:
                                    return parent.parentValue && quest.parentOptionId === parent.parentValue
                                case ApplyV2CustomFieldTypeConst.MultiSelect:
                                    return (Array.isArray(parent.parentValue) ? parent.parentValue : []).includes(
                                        quest.parentOptionId
                                    )
                                default:
                                    return false
                            }
                        default:
                            return true
                    }
                })
                .map((question) => {
                    return (
                        <ApplyV2QuestionsItem
                            key={question.questionId}
                            question={question}
                            setIsErrorUpdateAnswer={setIsErrorUpdateAnswer}
                            refetchAllQuestions={refetchAllQuestions}
                            addLoadingItem={addLoadingItem}
                            removeLoadingItem={removeLoadingItem}
                            setIsQualifyingError={setIsQualifyingError}
                        />
                    )
                })}
        </div>
    )
}

export default ApplyV2QuestionsList
